import { Component, OnInit } from '@angular/core';
import { IUser, UserService } from '@app/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
})
export class LayoutComponent implements OnInit {
  constructor(private _user: UserService) {
    this.checkAuthUser();
  }

  ngOnInit() {}

  async checkAuthUser() {
    if (localStorage.getItem('xsrf')) {
      if (!this._user.authState.getValue()) {
        this._user.authState.next(true);
        this._user.authuser().then((res: any) => {
          if (res.status && res.user) {
            this._user.authUser.next(res.user);
          } else {
            localStorage.removeItem('xsrf');
            this._user.authState.next(false);
            this._user.authUser.next({} as IUser);
          }
        });
      }
    }
  }
}
